var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGnbCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6A6A6A",
    stroke: "#6A6A6A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51544 6.58746C2.59704 5.96526 3.12731 5.5 3.75483 5.5H15.3551C15.9524 5.5 16.4663 5.92262 16.5816 6.50872L18.7947 17.7587C18.9467 18.5311 18.3554 19.25 17.5682 19.25H2.27942C1.52451 19.25 0.941871 18.586 1.04003 17.8375L2.51544 6.58746Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.75C6 1.67893 7.67893 0 9.75 0C11.8211 0 13.5 1.67893 13.5 3.75V8C13.5 8.41421 13.1642 8.75 12.75 8.75C12.3358 8.75 12 8.41421 12 8V3.75C12 2.50736 10.9926 1.5 9.75 1.5C8.50736 1.5 7.5 2.50736 7.5 3.75V8C7.5 8.41421 7.16421 8.75 6.75 8.75C6.33579 8.75 6 8.41421 6 8V3.75Z",
    fill: "current",
    stroke: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGnbCart);
export default __webpack_public_path__ + "static/media/icon__gnb-cart.d575a9f607d345b34c1eb00808086045.svg";
export { ForwardRef as ReactComponent };